// @core/api/endpoints/task/create_container_config.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ContainerConfigResponse,
  CreateContainerConfigRequest,
} from '../../../types/task';

const BASE_PATH = '/task';

/**
 * Create container config
 * Creates task configuration for a parent entity (project, team, pipeline, etc.). Configures allowed types, defaults, key prefixes, and workflow overrides.
 */
export async function CreateContainerConfig(
  data: CreateContainerConfigRequest,
  options?: RequestOptions
): Promise<ContainerConfigResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/container-configs`;
  const requestOptions = options;
  return client.post<ContainerConfigResponse>(requestPath, data, requestOptions);
}
